import type { FaireProductEntity } from "../../entity_types/product";

export const p_bvyqe5kjz5: FaireProductEntity = {
  token: "p_bvyqe5kjz5",
  type: "product",
  name: "Children's Parasite Cleanse Infusion - Glycerine Based",
  brandToken: "b_2ap734k32w",
  brandName: "Simply Honest Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/366a771bdf6073e83d3a68554ff0710d5ffe5d093adb77b078726ea826190d63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ce7680710754e86f6068c5e9e0d49271ae935ca65f4f5db060ef071b32dd7d2.jpeg",
    "https://cdn.faire.com/fastly/5398170416e6817a1b0c9df3c1e39358efbce566224ba047f4f113e2edaeeaab.jpeg",
    "https://cdn.faire.com/fastly/a1faeacd6d9e36a599ddf5855e91fa82a116b31f3372f7978edc02287b5b5825.jpeg",
    "https://cdn.faire.com/fastly/9f1dc100d62a1ec0eb9c30e68e030a6c79645120a5d151f37ba9bcc6c19e7c79.jpeg",
    "https://cdn.faire.com/fastly/6fa8ceb4ff32e11f577151c9bc3a691878ad605fbc363114bd66f52d8e1f7195.jpeg",
  ],
  priceDollars: 48.3,
  description:
    "Due to word limitations on Faire, our product descriptions are not complete. You can find more information and complete details on our website at https://SimplyHonestCo.com\n\nHerbal Ingredients:\nFennel Seed – Calms digestive upset and helps expel gas\nGinger Root – Soothes the stomach and supports elimination\nThyme Leaf – Traditionally used to help fight internal invaders\nClove Buds – Known for targeting parasite eggs\nWormwood – A powerful traditional herb to support cleansing\nSlippery Elm Bark Powder – A natural binder that soothes and protects the gut lining\nVegetable Glycerine &amp; Distilled Water – Extract and preserve the herbal benefits with a sweet, kid-friendly taste",
  tags: [],
  msrpDollars: 69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:17.777Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
